import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'sa-nav-filter-msg',
  templateUrl: './nav-filter-msg.component.html',
  styleUrls: ['./nav-filter-msg.component.scss']
})
export class NavFilterMsgComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
